// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"wxUyZBYcRtR58RkXl5JQc"};